export default {"src":"/_next/static/media/phone.7a0dd1e8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};